import { render, staticRenderFns } from "./smMain.vue?vue&type=template&id=754dc9c9&scoped=true&"
import script from "./smMain.vue?vue&type=script&lang=js&"
export * from "./smMain.vue?vue&type=script&lang=js&"
import style0 from "./smMain.vue?vue&type=style&index=0&id=754dc9c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754dc9c9",
  null
  
)

export default component.exports